import { RolexContainer } from '../Container'
import { RolexProductPageHeroPrice } from './Price'
import { Icon, Image } from '@components/gassan-ui'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import CtaButtons from '../CtaButtons'

type RolexProductPageHeroProps = {
  kenticoImage: AssetsElement
  title: string
  description: string
  price?: number
}

export const RolexProductPageHero: FC<RolexProductPageHeroProps> = ({
  kenticoImage,
  title,
  description,
  price,
}) => {
  const { t } = useTranslation('other')
  return (
    <section
      className={cn('relative bg-rolexLightBeige pb-[50px]', 'md:h-[50vh] md:pb-0', 'lg:h-[70vh]')}
    >
      <RolexContainer as="div" className="relative h-[60vh] w-full md:h-full">
        <Image
          className="h-full"
          objectFit="contain"
          sources={[768, 1024].map((width) =>
            getKontentImage(kenticoImage.value[0].url, { width }),
          )}
          alt={kenticoImage.value[0].description}
          placeholder={getKontentImage(kenticoImage.value[0].url, { width: 50 })}
        />
      </RolexContainer>
      <RolexContainer
        as="div"
        className={cn(
          'z-[2] mt-1',
          'md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2',
        )}
      >
        <div className="w-fit">
          <h1 className="flex flex-col gap-2">
            <Text variant="body24" as="span" className="text-rolexBrown">
              Rolex
            </Text>
            <Heading variant="headline50" as="span" className="text-rolexBrown">
              {title}
            </Heading>
            <Text variant="body20" weight="light" as="span">
              {description} <br />
              {price && <RolexProductPageHeroPrice price={price} />}
            </Text>
          </h1>
          <CtaButtons
            phoneNumber="+31 (0)20 622 5333"
            findStore
            sendMessage
            className="border-b border-rolexBrown/20 py-[30px]"
          />
          <button onClick={() => handleGoToAvailability()} className="mt-2 flex items-center">
            <Text variant="fixed14" className="text-rolexBrown">
              {t('modelAvailability')}
            </Text>
            <Icon icon="info" />
          </button>
        </div>
      </RolexContainer>
    </section>
  )

  function handleGoToAvailability() {
    const availableEl = document.getElementById('model-availability')
    if (availableEl && availableEl.offsetTop) {
      window.scrollTo({ top: availableEl.offsetTop - 80, left: 0, behavior: 'smooth' })
    }
  }
}
